import { Observable } from 'rxjs';
import { ApiService } from 'src/app/services/api/api.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VideoArchivesSettingsService {

  constructor(private apiService: ApiService) {}

  // createUserVideos(videosInfo): Observable<any> {
  //   return this.apiService.postFile('users/createUserVideos', videosInfo);
  // }

  // updateUserVideos(videosInfo): Observable<any> {
  //   return this.apiService.postFile('users/updateUserVideos', videosInfo);
  // }

  // getUserVideos(): Observable<any> {
  //   return this.apiService.get('users/getUserVideos');
  // }

  createUserVideo(videoInfo): Observable<any> {
    return this.apiService.postFile('users/createUserVideo', videoInfo);
  }

  updateUserVideo(id, videoInfo): Observable<any> {
    return this.apiService.putFile(`users/updateUserVideo/${id}`, videoInfo);
  }

  deleteUserVideo(id): Observable<any> {
    return this.apiService.delete(`users/deleteUserVideo/${id}`);
  }

  getUserVideo(id): Observable<any> {
    return this.apiService.get(`users/getUserVideo/${id}`);
  }

  getMyUserVideos(): Observable<any> {
    return this.apiService.get('users/getUserVideoListing');
  }
}
